
import { Component, OnInit, Input } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { FormControl } from '@angular/forms';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ActivatedRoute } from '@angular/router';
import { ViolationModel } from 'app/shared/violation-interface';
import { SelectItem } from 'primeng/primeng';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-user-violation',
  templateUrl: './user-violation.component.html',
  styleUrls: ['./user-violation.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class UserViolationComponent implements OnInit {

  objectId: string;
  profileId = '';
  data: any;
  datas: any[];
  violationsData: ViolationModel[] = [];
  selectbydate = new Date();
  selectedMonth: any;
  maxWorkingDays = 0;
  selectedStatus = 'all';
  inTimeCount = 0;
  inCompletedHrsCount = 0;
  breakHrsCount = 0;
  selectedDate: Date = new Date();
  name: string;
  statusSelectItem: SelectItem[];
  @Input() id: string;
  @Input() mode: string;
  date = new FormControl(moment());
  currentDate = new Date();

  constructor(
    private parseService: ParseService,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit() {
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    let id = '';
    this.route.params.subscribe(params => {
      id = params['id'];
    });

    if (id != undefined) {
      this.profileId = id;
    }

    if (this.objectId) {
      var user = new this.parseService.instance.Object('Profile');
      user.id = this.objectId;
    }

    this.statusSelectItem = [
      { label: 'All', value: 'all' },
      { label: 'Open', value: 'open' },
      { label: 'Resolved', value: 'resolved' },
      { label: 'Escalated', value: 'escalated' },
    ];
    this.getEmployeeViolations(this.selectedStatus);
    this.getWorkingDays(new Date());
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.selectedDate = this.date.value._d;
    this.getWorkingDays(this.date.value._d);
    this.getEmployeeViolations(this.selectedStatus);
  }

  getWorkingDays(event) {
    var date = new Date(event);
    var month = date.getMonth();
    var year = date.getFullYear();
    date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {

      // Exclude weekends
      var tmpDate = new Date(date);
      var weekDay = tmpDate.getDay(); // week day
      var day = tmpDate.getDate(); // day

      if (weekDay % 6) { // exclude 0=Sunday and 6=Saturday
        days.push(day);
      }
      date.setDate(date.getDate() + 1);
    }
    this.maxWorkingDays = days.length + 2;
  }


  getEmployeeViolations(status) {
    if (status == '') {
      status = 'all';
      this.selectedStatus = 'all';
    }
    this.violationsData = [];
    let startend = this.startenddates(this.selectedDate);
    let queryInstance = this.parseService.instance.Object.extend('UserViolations');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('userProfileId');
    query.include('reportingTo');
    query.include('userProfileId.role');
    query.greaterThan('violatedDate', startend[0]);
    query.lessThan('violatedDate', startend[1]);
    query.descending('updatedAt');
    if (status != 'all') {
      query.equalTo('status', status);
    }
    query.equalTo('userProfileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    query.find().then(results => {
      let violations = [];
      results.forEach(element => {
        let violate: ViolationModel = new ViolationModel();
        let vDate = element.get('violatedDate');
        violate.violatedDate = new Date(vDate);
        violate.userProfileId = element.get('userProfileId');
        this.name = violate.userProfileId.get('firstName') + ' ' + violate.userProfileId.get('lastName');
        violate.startTime = element.get('userProfileId').get('officialInfo').startTime;
        violate.violations = element.get('violations');
        violate.status = element.get('status');
        violate.reportingTo = element.get('reportingTo');
        violate.resolvedBy = element.get('resolvedBy');
        violate.resolvedDate = element.get('resolvedDate');
        violate.objectId = element.id;
        violations.push(violate);
      });
      this.violationsData = violations;
      this.inTimeCount = 0;
      this.inCompletedHrsCount = 0;
      this.breakHrsCount = 0;
      violations.forEach(element => {
        element.violations.forEach(innerElement => {
          if (innerElement.type == 'In-Time') {
            this.inTimeCount += 1
          }
          if (innerElement.type == 'Incompleted-Hours') {
            this.inCompletedHrsCount += 1
          }
          if (innerElement.type == 'Exceeded-Break-Hours') {
            this.breakHrsCount += 1
          }
        });
      });
    });

  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }


}

